import Helper from '@ember/component/helper';
import { scheduleOnce } from '@ember/runloop';

export const classFactory = (getElement) => {
  const classMap = new Map();

  let oldClasses = new Set();

  const applyClasses = () => {
    const newClasses = [...classMap].reduce((accum, [, classes]) => {
      classes.forEach(accum.add, accum);
      return accum;
    }, new Set());

    const removedClasses = [...oldClasses].filter(
      (clazz) => !newClasses.has(clazz),
    );

    const root = getElement();
    root.classList.add(...newClasses);
    root.classList.remove(...removedClasses);

    oldClasses = newClasses;
  };

  return class HigherOrderClassNameHelper extends Helper {
    compute([value]) {
      const trimmedValue = value?.trim();
      const splitValue = trimmedValue ? trimmedValue.split(/\s+/) : [];
      classMap.set(this, splitValue);
      scheduleOnce('afterRender', null, applyClasses);
    }

    willDestroy() {
      super.willDestroy();
      classMap.delete(this);
      scheduleOnce('afterRender', null, applyClasses);
    }
  };
};

export default classFactory(() => document.body);
